module.exports = __webpack_public_path__ + "img/neobet_2026_2_640x200.f32df05e.png";